module.exports = __webpack_public_path__ + "img/Ambassadorship.959c9c76.png";